import Text from '../../atoms/Text';
import Input from '../../atoms/Input';
import Button from '../../atoms/Button';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import { SubmitHandler, useForm } from 'react-hook-form';
import { useEffect, useMemo, useState, useCallback } from 'react';
import LITERALS from '../../../shared/constants/literals';
import { REGEX } from '../../../shared/constants/regex';
import {
	cancelLinkFlowHeru,
	getPollingLinkFlowHeru,
	postSATLinkFlowHeru,
} from '../../../services/satLinking.service';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import InputFile from '../../atoms/InputFile';

import {
	CheckCircle,
	ClipboardText,
	Clock,
	ClockCountdown,
	Hammer,
	LockSimpleOpen,
	Warning,
	WarningDiamond,
} from '@phosphor-icons/react';
import { showAlert, AlertPayload } from '../../../redux/slices/alert.slice';
import { ALERT_TYPE } from '../Alert';
import {
	ANALYTICS_EVENTS,
	EVENT_TYPES,
} from '../../../shared/constants/events';
import {
	msgToolTipPassword,
	msgTooltip,
} from '../../../shared/constants/SatLinkMessages';
import Modal from '../Modal/Modal';
import clevertap from 'clevertap-web-sdk';
import Divider from '../../atoms/Divider';
import { POLLING_STEP } from '../../../@types/SATLinking';
import useClevertapEvent from '../../../hooks/useClevertapEvent';
import { CircularProgress } from '@mui/material';

type SATLinkForm = {
	rfc: string;
	password: string;
};

export type SATEFirmaForm = {
	cert: any;
	key: any;
	password: string;
};

interface Props {
	sx?: string;
	onCallbackSuccess?: (value: any) => void;
	onCallbackError?: (error: any) => void;
	title?: string;
	showEFirmaForm?: boolean;
	showTabs: (value: boolean) => void;
}

export const schemaSATLinking = yup
	.object()
	.shape({
		rfc: yup
			.string()
			.required(LITERALS.REQUIRED_FIELD)
			.matches(REGEX.rfcRegex, LITERALS.REG_EXP_RFC),
		password: yup.string().required(LITERALS.REQUIRED_FIELD),
		// .matches(REGEX.nameRegex, LITERALS.PASSWORD_INVALID)
		// .min(8, LITERALS.MIN_LENGTH_PASSWORD),
	})
	.required(LITERALS.REQUIRED_FIELD);

const schemaEFirma = yup
	.object({
		key: yup.mixed().required(LITERALS.REQUIRED_FIELD),
		cert: yup.mixed().required(LITERALS.REQUIRED_FIELD),
		password: yup.string().required(LITERALS.REQUIRED_FIELD),
		// .matches(REGEX.nameRegex, LITERALS.MIN_LENGTH_PASSWORD)
		// .min(8, LITERALS.MIN_LENGTH_PASSWORD),
	})
	.required(LITERALS.REQUIRED_FIELD);

const SATLinkingForm = ({
	sx,
	onCallbackSuccess,
	onCallbackError,
	title,
	showEFirmaForm,
	showTabs,
}: Props) => {
	const {
		control,
		handleSubmit,
		formState: { errors },
		setError: setErrorRfc,
	} = useForm<SATLinkForm>({
		resolver: yupResolver(schemaSATLinking),
		defaultValues: {
			rfc: '',
			password: '',
		},
	});

	const {
		control: controlEFirma,
		handleSubmit: handleSubmitEFirma,
		formState: { errors: errorsEFirma },
		setValue: setValueEFirma,
	} = useForm<SATEFirmaForm>({
		resolver: yupResolver(schemaEFirma),
		defaultValues: {
			cert: undefined,
			key: undefined,
			password: '',
		},
	});

	const satConnectionMessages = [
		'Estamos conectando de forma segura con el SAT para vincular tus credenciales...',
		'Verificando la autenticidad de tus datos. Este proceso puede tomar unos momentos...',
		'Estableciendo una conexión encriptada con el SAT. Tu seguridad es nuestra prioridad...',
		'Sincronizando tu información fiscal. Este paso es fundamental para gestionar correctamente tus impuestos...',
		'Estamos procesando tus credenciales. Los servidores del SAT pueden responder con diferente velocidad según la hora del día...',
		'Configurando tu perfil fiscal en heru. Este paso nos permite ofrecerte el mejor servicio personalizado...',
		'Validando tus datos con el SAT. Esta conexión nos permite gestionar tus impuestos de forma precisa...',
		'Creando un canal seguro entre heru y el SAT. Tu información está protegida en todo momento...',
		'La comunicación con los servidores del SAT puede tomar unos instantes. Estamos trabajando para completar el proceso lo antes posible...',
		'Casi listo... Estamos finalizando la vinculación de tus credenciales para poder comenzar a simplificar tus impuestos...',
	];

	const [isLoading, setIsLoading] = useState(false);
	const [numbersOfIntents, setNumbersOfIntents] = useState(0);
	const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
	const [openMondal, setOpenMondal] = useState(false);
	const [userRFC, setUserRFC] = useState('');
	const [messageError, setMessageError] = useState('');
	const [timer, setTimer] = useState(0);
	const [timerInterval, setTimerInterval] = useState<NodeJS.Timeout | null>(
		null,
	);
	const [checkFlowStep1, setCheckFlowStep1] = useState(false);
	const [checkFlowStep2, setCheckFlowStep2] = useState(false);

	const [viewMessageRefresh, setViewMessageRefresh] = useState(false);
	const { tokenSession } = useSelector((state: RootState) => state.auth);
	const userProfile = useSelector((state: RootState) => state.profile.user);

	const loaderImages = useMemo(
		() => [
			<ClockCountdown
				size={40}
				weight='duotone'
				color='#1790EC'
			/>,
			<Hammer
				size={40}
				weight='duotone'
				color='#1790EC'
			/>,
			<ClipboardText
				size={40}
				weight='duotone'
				color='#1790EC'
			/>,
		],
		[],
	);

	const dispatch = useDispatch();
	const { dataLayer } = window as any;
	const logClevertapEvent = useClevertapEvent();

	const logLinkEvent = (source: 'rfc' | 'Efirma', rfc?: string) => {
		logClevertapEvent(ANALYTICS_EVENTS.HOME_LINK, {
			event_type: EVENT_TYPES.HOME_LINK_ATTEMP,
			id: userProfile?.id!,
			phone: userProfile?.cellphone!,
			source,
		});

		dataLayer.push({
			event: ANALYTICS_EVENTS.ADD_RFC,
			user_id: userProfile?.id,
			phone: userProfile?.cellphone,
			rfc: rfc,
		});
	};

	const showAlertTop = ({ title, type, description }: AlertPayload) => {
		const alert = {
			type,
			title,
			description,
		};
		dispatch(showAlert(alert));
	};

	const updateLoading = (value: boolean) => {
		showTabs(value);
	};

	const successLinkHandler = async (resp: unknown, rfc?: string) => {
		clevertap.profile.push({
			Site: {
				rfc: rfc ? rfc : userRFC,
			},
		});
		showAlertTop({
			title: 'Éxito',
			type: ALERT_TYPE.SUCCESS,
			description: LITERALS.SUCCESS_SAT_LINK,
		});
		setIsLoading(false);
		updateLoading(true);
		onCallbackSuccess?.(resp);
	};

	const cancelLinkFlowHandler = async () => {
		try {
			const workflowId = localStorage.getItem('workflowId');
			if (!workflowId) return;
			const response = await cancelLinkFlowHeru(
				workflowId,
				showEFirmaForm ? 'efirma' : 'link',
				tokenSession,
			);
			if (response?.status === 200) {
				localStorage.removeItem('workflowId');
				setIsLoading(false);
				updateLoading(true);
				setMessageError('');
			}
		} catch (error) {}
	};

	//? Step 2 - POLLING SAT LINK FLOW
	const pullingLinkHandler = useCallback(
		async (workflowId: string, refresh?: boolean) => {
			try {
				const response = await getPollingLinkFlowHeru(
					workflowId,
					showEFirmaForm ? 'efirma' : 'link',
					tokenSession,
				);
				switch (response?.currentState) {
					case POLLING_STEP.SAT_CONNECTION_ATTEMPT_CREATED:
					case POLLING_STEP.SAT_CONNECTION_EXECUTED:
					case POLLING_STEP.STORE_SAT_CONNECTION_DATA:
						setCheckFlowStep1(true);
						setTimeout(() => {
							pullingLinkHandler(workflowId);
						}, 2000);
						break;

					case POLLING_STEP.COMPLETED:
						if (refresh) return;
						setCheckFlowStep2(true);
						setTimeout(() => {
							successLinkHandler(response);
						}, 2000);
						break;

					case POLLING_STEP.FAILED:
						if (refresh) {
							setViewMessageRefresh(true);
							return;
						}
						setMessageError(response.error);
						if (
							response.error ===
							'Al parecer la contraseña no coincide. ¿Podrías intentar nuevamente?'
						) {
							setErrorRfc('password', {
								type: 'manual',
								message: response.error,
							});
						}
						setValueEFirma('cert', undefined);
						setValueEFirma('key', undefined);
						setIsLoading(false);
						updateLoading(true);
						showAlertTop({
							title: 'Error',
							type: ALERT_TYPE.ERROR,
							description: response.error,
						});
						

						break;

					default:
						break;
				}
			} catch (error) {
				// @ts-ignore
				if (error?.response?.data?.msg) {
					showAlertTop({
						title: 'Error',
						type: ALERT_TYPE.ERROR,
						// @ts-ignore
						description: error.response.data.msg,
					});
				} else {
					showAlertTop({
						title: 'Error',
						type: ALERT_TYPE.ERROR,
						description: LITERALS.FISCAL_LINK_ERROR,
					});
				}
				onCallbackError?.(error);
				setIsLoading(false);
				updateLoading(true);
			}
		},
		[userProfile?.id, tokenSession, timerInterval, showEFirmaForm],
	);

	useEffect(() => {
		let interval: NodeJS.Timeout | null = null;

		if (isLoading) {
			setTimer(0);
			interval = setInterval(() => {
				setTimer((prevTimer) => prevTimer + 1);
			}, 1000);
			setTimerInterval(interval);
		} else {
			if (timerInterval) {
				clearInterval(timerInterval);
				setTimerInterval(null);
			}
			setTimer(0);
		}

		return () => {
			if (interval) {
				clearInterval(interval);
			}
			if (timerInterval) {
				clearInterval(timerInterval);
			}
		};
	}, [isLoading]);

	//? Step 1 - Link with rfc and password
	const onSubmit: SubmitHandler<SATLinkForm> = async (data) => {
		if (!userProfile?.id || isLoading) return;
		logLinkEvent('rfc', data.rfc);
		if (numbersOfIntents === 4) {
			setNumbersOfIntents(0);
		}
		try {
			setIsLoading(true);
			updateLoading(false);
			const userData = {
				userId: userProfile?.id,
				rfc: data.rfc,
				password: data.password,
			};
			setUserRFC(data.rfc);
			const resp = await postSATLinkFlowHeru('link', userData, tokenSession);
			if (resp?.WorkflowId) {
				pullingLinkHandler(resp?.WorkflowId);
				localStorage.setItem('workflowId', resp?.WorkflowId);
			} else if (resp?.statusCode === 422) {
				setErrorRfc('rfc', {
					type: 'manual',
					message: resp.message,
				});
				setMessageError(resp.message);
				showAlertTop({
					title: 'Error',
					type: ALERT_TYPE.ERROR,
					description: resp.message,
				});
				setIsLoading(false);
				updateLoading(true);
			}
		} catch (error) {
			// @ts-ignore
			if (error?.response?.data?.msg) {
				showAlertTop({
					title: 'Error',
					type: ALERT_TYPE.ERROR,
					// @ts-ignore
					description: error.response.data.msg,
				});
			} else {
				showAlertTop({
					title: 'Error',
					type: ALERT_TYPE.ERROR,
					description: LITERALS.FISCAL_LINK_ERROR,
				});
			}
			setNumbersOfIntents(numbersOfIntents + 1);
			setIsLoading(false);
			updateLoading(true);
			onCallbackError?.(error);
		}
	};

	//? Link with efirma

	const onSubmitEFirma: SubmitHandler<SATEFirmaForm> = async (data) => {
		if (!userProfile?.id || isLoading) return;
		logLinkEvent('Efirma');
		if (!data.cert || !data.key || !data.password) {
			showAlertTop({
				title: 'Error',
				type: ALERT_TYPE.ERROR,
				description: LITERALS.REQUIRED_FIELDS,
			});
			return;
		}
		try {
			setIsLoading(true);
			updateLoading(false);
			const formData = new FormData();
			formData.append('cert', data.cert, data.cert.name);
			formData.append('key', data.key, data.key.name);
			formData.append('password', data.password);
			formData.append('userId', String(userProfile?.id));
			const resp = await postSATLinkFlowHeru('efirma', formData, tokenSession);
			if (resp?.WorkflowId) {
				pullingLinkHandler(resp?.WorkflowId);
				localStorage.setItem('workflowId', resp?.WorkflowId);
			} else if (resp?.statusCode === 422) {
				setErrorRfc('rfc', {
					type: 'manual',
					message: resp.detail.msg,
				});
				setMessageError(resp.detail.msg);
				showAlertTop({
					title: 'Error',
					type: ALERT_TYPE.ERROR,
					description: resp.detail.msg,
				});
				setIsLoading(false);
				updateLoading(true);
			}
		} catch (error) {
			// @ts-ignore
			if (error?.response?.data?.msg) {
				// @ts-ignore
				showAlertTop({
					title: 'Error',
					type: ALERT_TYPE.ERROR,
					// @ts-ignore
					description: error.response.data.msg,
				});
			} else {
				showAlertTop({
					title: 'Error',
					type: ALERT_TYPE.ERROR,
					description: LITERALS.FISCAL_LINK_ERROR,
				});
			}
			setNumbersOfIntents(numbersOfIntents + 1);
			setIsLoading(false);
			updateLoading(true);
			onCallbackError?.(error);
		}
	};

	useEffect(() => {
		if (numbersOfIntents === 3) {
			showAlertTop({
				title: 'Alerta',
				type: ALERT_TYPE.WARNING,
				description: '¿Necesitas ayuda?',
			});
		}
	}, [numbersOfIntents]);

	const text = useMemo(
		() =>
			showEFirmaForm
				? 'No tengo e.firma'
				: ' No tengo contraseña SAT o la olvidé',
		[showEFirmaForm],
	);

	useEffect(() => {
		const workflowId = localStorage.getItem('workflowId');
		if (workflowId) {
			setTimer(0);
			if (timerInterval) {
				clearInterval(timerInterval);
				setTimerInterval(null);
			}
			pullingLinkHandler(workflowId, true);
		}
	}, []);

	useEffect(() => {
		if (isLoading) {
			const messageIntervalId = setInterval(() => {
				setCurrentMessageIndex((prevIndex) => {
					const nextIndex = (prevIndex + 1) % satConnectionMessages.length;
					return nextIndex;
				});
			}, 6000);

			return () => {
				clearInterval(messageIntervalId);
			};
		}
	}, [isLoading, satConnectionMessages]);

	return (
		<div className={`${sx}`}>
			<Modal
				open={openMondal}
				onClose={() => setOpenMondal(false)}
			>
				<div className='!w-[calc(100vw-60px)] max-w-[500px] h-[calc(100vh-100px)] pt-6 relative'>
					<Text
						size='s'
						sx='text-left pl-2 pr-2 bg-h-gray-10 flex justify-center py-6 mt-[-20px] z-10'
						color='medium'
					>
						Te hemos conectado con SATID, la plataforma oficial del SAT para que
						generes tu contraseña. Selecciona "Generación de contraseña" y sigue
						los pasos marcados en la plataforma.
					</Text>
					<iframe
						title='Embedded Page'
						width='100%'
						height='100%'
						src='https://satid.sat.gob.mx/'
						allowFullScreen
					></iframe>
				</div>
			</Modal>

			{isLoading && (
				<div className='p-6'>
					<div className='flex flex-col items-center'>
						<div className='relative w-[60px] h-[60px] mx-auto mb-4 bg-[#F4F9FE] rounded-full flex items-center justify-center'>
							<CircularProgress
								size={60}
								thickness={2}
								sx={{
									position: 'absolute',
									top: 0,
									left: 0,
									color: '#1790EC',
								}}
							/>
							{loaderImages[currentMessageIndex % loaderImages.length]}
						</div>
						<div className='flex flex-col items-center justify-center w-[350px]'>
							<Text
								size='caption'
								weight='light'
								sx='mb-4 flex items-center gap-1'
							>
								<Clock size={16} />
								{Math.floor(timer / 60)}:
								{String(Math.floor(timer % 60)).padStart(2, '0')}
							</Text>
							<Text
								size='body-3'
								weight='regular'
							>
								Validando tus credenciales
							</Text>
							<Text
								size='mini-1'
								weight='light'
								color='medium'
								sx='text-center mt-2'
							>
								{satConnectionMessages[currentMessageIndex]}
							</Text>
							<div className='flex flex-col justify-start gap-2 mt-4 w-full'>
								<div className='flex items-center gap-2'>
									<CheckCircle
										size={16}
										color='#6BA233'
										weight='duotone'
									/>
									<Text
										size='mini-1'
										weight='light'
									>
										Archivos recibidos
									</Text>
								</div>
								<div className='flex items-center gap-2'>
									{checkFlowStep1 ? (
										<CheckCircle
											size={16}
											color='#6BA233'
											weight='duotone'
										/>
									) : (
										<CircularProgress
											size={13}
											color='primary'
										/>
									)}
									<Text
										size='mini-1'
										weight='light'
									>
										Procesando tu información
									</Text>
								</div>
								<div className='flex items-center gap-2'>
									{checkFlowStep2 ? (
										<CheckCircle
											size={16}
											color='#6BA233'
											weight='duotone'
										/>
									) : (
										<CircularProgress
											size={13}
											color='primary'
										/>
									)}
									<Text
										size='mini-1'
										weight='light'
									>
										Validación completa
									</Text>
								</div>
							</div>
							{timer < 300 && (
								<div className='bg-[#fffbeb] rounded-lg px-3 py-4 mt-4 w-full flex items-start gap-2 border border-[#854d0e]'>
									<div>
										<WarningDiamond
											size={16}
											color='#854d0e'
											weight='fill'
										/>
									</div>

									<div>
										<Text
											size='mini-1'
											weight='medium'
											sx='text-[#854d0e]'
										>
											Estamos validando y vinculando tus credenciales ante el
											SAT.
										</Text>
										<ul className='list-disc ml-4'>
											<li>
												<Text
													size='mini-1'
													weight='light'
													sx='text-[#854d0e]'
												>
													Puedes explorar otras secciones mientras tanto.
												</Text>
											</li>
											<li>
												<Text
													size='mini-1'
													weight='light'
													sx='text-[#854d0e]'
												>
													Si crees que ingresaste mal tu contraseña, pulsa
													"Detener" e inténtalo de nuevo.
												</Text>
											</li>
										</ul>
									</div>
								</div>
							)}
							{timer >= 300 && (
								<div className='bg-[#fecdd3] rounded-lg px-3 py-4 mt-4 w-full flex items-start gap-2 border border-[#dc2626]'>
									<div>
										<WarningDiamond
											size={16}
											color='#dc2626'
											weight='fill'
										/>
									</div>

									<div>
										<Text
											size='mini-1'
											weight='medium'
											sx='text-[#7c2d12]'
										>
											El proceso está tomando más tiempo del habitual. Seguimos
											intentando conectar con el SAT.
										</Text>
										<Text
											size='mini-1'
											weight='light'
											sx='text-[#7c2d12]'
										>
											En ocasiones, los servidores del SAT pueden estar
											congestionados. Te recomendamos no detener la vinculación.
										</Text>
									</div>
								</div>
							)}
						</div>
					</div>
				</div>
			)}

			{showEFirmaForm && (
				<>
					{!isLoading && (
						<form onSubmit={handleSubmitEFirma(onSubmitEFirma)}>
							<div className='flex flex-col gap-4'>
								<Text size='m'>Certificado</Text>
								<InputFile
									control={controlEFirma}
									name='cert'
									accept='.cer'
									errorMessage={errorsEFirma.cert?.message as string}
									label='Sube tu certificado (.cer)'
								/>
								<Text size='m'>Clave privada</Text>
								<InputFile
									control={controlEFirma}
									name='key'
									accept='.key'
									errorMessage={errorsEFirma.key?.message as string}
									label='Sube tu clave privada (.key)'
								/>
								<Input
									label='Contraseña clave privada'
									showTooltip
									tooltipMessage={msgToolTipPassword}
									control={controlEFirma}
									name='password'
									type='password'
									placeholder='Contraseña clave privada'
									errorMessage={errorsEFirma.password?.message}
									maxLength={50}
									rules={{ required: true }}
								/>
								<Button
									loading={isLoading}
									disabled={
										!!errorsEFirma.key ||
										!!errorsEFirma.cert ||
										!!errorsEFirma.password ||
										isLoading
									}
									label='Vincular mi e.firma'
									type='submit'
								/>
							</div>
						</form>
					)}
				</>
			)}
			{!showEFirmaForm && (
				<>
					{!isLoading && (
						<form onSubmit={handleSubmit(onSubmit)}>
							<div className='flex flex-col gap-4'>
								{title && (
									<>
										<Text
											size='body-2'
											weight='bold'
											sx='hidden lg:block'
										>
											{title}
										</Text>
										<Text
											size='body-3'
											weight='bold'
											sx='block lg:hidden'
										>
											{title}
										</Text>
										<Divider />
									</>
								)}
								<Input
									label='RFC'
									control={control}
									name='rfc'
									type='text'
									placeholder='Ingresa tu RFC'
									errorMessage={errors.rfc?.message}
									autofocus
									maxLength={13}
									showValueUpperCase
									showTooltip
									tooltipMessage={msgTooltip}
								/>

								<Input
									label='Contraseña Plataforma SAT'
									control={control}
									name='password'
									type='password'
									placeholder='Contraseña Plataforma SAT'
									errorMessage={errors.password?.message}
									showTooltip
									tooltipMessage={msgToolTipPassword}
								/>
								<Button
									loading={isLoading}
									disabled={!!errors.rfc || !!errors.password || isLoading}
									label='Vincular mi RFC'
									type='submit'
								/>
							</div>
						</form>
					)}
				</>
			)}

			<div className={`${isLoading ? 'mt-0' : 'mt-4'} justify-center`}>
				{isLoading && (
					<div className='flex justify-center mb-4'>
						<Button
							variant='text'
							label='Detener mi vinculación'
							onClick={cancelLinkFlowHandler}
							labelColor='primary'
						/>
					</div>
				)}
				{!isLoading && (
					<>
						<div className='flex flex-col mb-4 mt-4'>
							<button
								type='button'
								className='w-full'
								onClick={() => setOpenMondal(true)}
							>
								<Text
									size='m'
									color='primary'
									sx='text-center justify-center'
									weight='medium'
								>
									{text}
								</Text>
							</button>
						</div>
						{messageError !== '' && (
							<div className='bg-[#fecdd3] rounded-lg px-3 py-4 mt-4 w-full flex items-center gap-2 border border-[#dc2626] mb-4'>
								<div className='flex items-center justify-center'>
									<Warning
										size={24}
										color='#dc2626'
										weight='fill'
									/>
								</div>

								<div>
									<Text
										size='mini-1'
										weight='medium'
										sx='text-[#7c2d12]'
									>
										Error, con tus credenciales
									</Text>
									<Text
										size='mini-1'
										weight='light'
										sx='text-[#7c2d12]'
									>
										{messageError}
									</Text>
								</div>
							</div>
						)}
						{viewMessageRefresh && !showEFirmaForm && (
							<div className='bg-[#fffbeb] rounded-lg px-3 py-4 mt-4 w-full flex items-start gap-2 border border-[#854d0e] mb-4'>
								<div>
									<WarningDiamond
										size={16}
										color='#854d0e'
										weight='fill'
									/>
								</div>

								<div>
									<Text
										size='mini-1'
										weight='medium'
										sx='text-[#854d0e]'
									>
										Parece que hubo un problema con tu RFC o contraseña en tu
										intento anterior.
									</Text>

									<Text
										size='mini-1'
										weight='light'
										sx='text-[#854d0e]'
									>
										Por favor, verifica que los datos ingresados sean correctos
										e inténtalo de nuevo.
									</Text>
								</div>
							</div>
						)}
						<div className='flex flex-row gap-x-2 items-start bg-gray-100 p-4 rounded'>
							<LockSimpleOpen
								size={20}
								className='flex-2'
							/>
							<div className='flex-1'>
								<Text
									size='s'
									color='dark'
									sx='mb-2'
								>
									Heru es una plataforma independiente, no afiliada al SAT ni a
									ninguna entidad gubernamental. Tu información fiscal se
									utiliza exclusivamente con el fin de brindarte nuestros
									servicios.
								</Text>
								<Text
									size='s'
									color='dark'
								>
									Tus credenciales están protegidas mediante cifrado de última
									generación, garantizando los más altos estándares de seguridad
									digital. No compartimos tu información con terceros sin tu
									autorización expresa.
								</Text>
							</div>
						</div>
					</>
				)}
			</div>
		</div>
	);
};

export default SATLinkingForm;
